import React from 'react';
import Container from './Container';

const Error = () => <Container>API Error... Restart page.</Container>;

export default Error;
